module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/dig-in-brunch-logo-7fff2592e39bbea31582be4937ed0156.png";